import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllStudentsResults() {
  return get(`${apiHost}/api/teacher/users/results`);
}
